import api from "PFCore/api";
import { WorkforceResponse } from "PFCore/hooks/queries/bookings/workforce/use_workforce_entries";
import { CalendarRange, QueryParams } from "PFTypes";

export type FetchWorkforceProfilesParams = QueryParams<
  any,
  {
    dateRange: CalendarRange;
    previousSearchId?: number;
  }
>;

export const fetchWorkforceProfiles = (data: FetchWorkforceProfilesParams) =>
  api<WorkforceResponse>({
    url: "booking_module/profiles/index",
    method: "POST",
    data
  });
